import { Button } from '@lune-fe/lune-ui-lib'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'

import TwoColumnsWithBackgroundImage from '@/components/TwoColumnsWithBackgroundImage'
import useDevice from '@/hooks/useDevice'

const GrowCustomerValue = () => {
    const { mdScreen } = useDevice()
    return (
        <TwoColumnsWithBackgroundImage
            backgroundImage={'/images/logistics/ais-tracking-desktop.png'}
            mobileBackgroundImage={'/images/logistics/ais-tracking-mobile.png'}
            sx={{
                minHeight: '480px',
            }}
            leftSide={
                <Box
                    sx={{
                        gap: mdScreen ? 3 : 4,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                    }}
                >
                    <Text variant={mdScreen ? 'h5' : 'h4'} sx={{ maxWidth: '435px' }}>
                        Discover how to grow customer value with industry-leading green logistics
                        solutions
                    </Text>
                    <Button rightIcon={<ArrowForwardOutlinedIcon />} href={'/logistics'}>
                        Learn more
                    </Button>
                </Box>
            }
            reversedOnMobile={false}
        />
    )
}

export default GrowCustomerValue
